/* Stickers by Jennifer Rebrand — theme JS
   Cart state via Shopify AJAX Cart API; drawer, hero slider,
   qty steppers, product gallery, mobile nav, load-more. */
(function () {
  'use strict';

  var money = function (cents) {
    var fmt = (window.SBJ && window.SBJ.moneyFormat) || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    return fmt.replace(/\{\{\s*amount[^}]*\}\}/, amount);
  };

  /* ---------------- Hero slideshow ---------------- */
  function initSlideshow(root) {
    var slides = root.querySelectorAll('.hero__slide');
    var dots = root.querySelectorAll('.hero__dot');
    if (!slides.length) return;
    var index = 0;
    var count = slides.length;

    function go(i) {
      index = ((i % count) + count) % count;
      slides.forEach(function (s, n) {
        var active = n === index;
        s.classList.toggle('hero__slide--active', active);
        s.setAttribute('aria-hidden', active ? 'false' : 'true');
        s.inert = !active;
      });
      dots.forEach(function (d, n) {
        d.classList.toggle('hero__dot--active', n === index);
        d.setAttribute('aria-current', n === index ? 'true' : 'false');
      });
    }
    root.querySelectorAll('[data-slide-prev]').forEach(function (b) {
      b.addEventListener('click', function () { go(index - 1); stopAuto(); });
    });
    root.querySelectorAll('[data-slide-next]').forEach(function (b) {
      b.addEventListener('click', function () { go(index + 1); stopAuto(); });
    });
    dots.forEach(function (d, n) {
      d.addEventListener('click', function () { go(n); stopAuto(); });
    });

    var timer = null;
    var autoplay = root.dataset.autoplay === 'true';
    var speed = (parseInt(root.dataset.speed, 10) || 5) * 1000;
    function stopAuto() { if (timer) { clearInterval(timer); timer = null; } }
    root.addEventListener('focusin', stopAuto);
    if (autoplay && count > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      timer = setInterval(function () { go(index + 1); }, speed);
      root.addEventListener('pointerenter', stopAuto, { once: true });
    }
    go(0);
  }
  document.querySelectorAll('[data-slideshow]').forEach(initSlideshow);

  var mobileNav = document.getElementById('MobileNav');
  var drawer = document.getElementById('CartDrawer');
  var activeDrawer = null;
  var drawerOpener = null;
  var inertElements = [];
  function drawerFocusables(root) {
    return Array.from(root.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select,textarea,[tabindex="0"]')).filter(function (el) {
      return el.tabIndex >= 0 && el.getClientRects().length && !el.closest('[hidden],[inert]');
    });
  }
  function closePanel() {
    if (!activeDrawer) return;
    activeDrawer.removeAttribute('open');
    inertElements.forEach(function (el) { el.inert = false; });
    inertElements = [];
    activeDrawer = null;
    document.body.classList.remove('drawer-open');
    document.querySelectorAll('[data-mobile-nav-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (drawerOpener && drawerOpener.isConnected) drawerOpener.focus({ preventScroll: true });
    drawerOpener = null;
  }
  function openPanel(panel) {
    if (!panel || activeDrawer === panel) return;
    closePanel();
    drawerOpener = document.activeElement;
    activeDrawer = panel;
    panel.setAttribute('open', '');
    panel.setAttribute('tabindex', '-1');
    document.body.classList.add('drawer-open');
    var branch = panel;
    while (branch.parentElement && branch !== document.body) {
      Array.from(branch.parentElement.children).forEach(function (el) {
        if (el !== branch && !el.inert && !/^(SCRIPT|STYLE|LINK)$/.test(el.tagName)) {
          el.inert = true;
          inertElements.push(el);
        }
      });
      branch = branch.parentElement;
    }
    (panel.querySelector('.cart-drawer__close, .mobile-nav__close') || drawerFocusables(panel)[0] || panel).focus({ preventScroll: true });
  }
  function openDrawer() { openPanel(drawer); }
  window.SBJopenCartDrawer = openDrawer;
  function bindDrawerChrome() {}
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-mobile-nav-open]');
    if (opener) {
      openPanel(mobileNav);
      opener.setAttribute('aria-expanded', 'true');
    }
    if (e.target.closest('[data-mobile-nav-close],[data-drawer-close]')) closePanel();
    var cartLink = e.target.closest('[data-cart-open]');
    if (cartLink && drawer && drawer.dataset.enabled !== 'false') {
      e.preventDefault();
      openDrawer();
    }
  });
  document.addEventListener('keydown', function (e) {
    if (!activeDrawer) return;
    if (e.key === 'Escape') { e.preventDefault(); closePanel(); }
    if (e.key !== 'Tab' || !activeDrawer) return;
    var items = drawerFocusables(activeDrawer);
    var first = items[0], last = items[items.length - 1];
    if (!items.length) { e.preventDefault(); activeDrawer.focus(); return; }
    if (e.shiftKey && (document.activeElement === first || !items.includes(document.activeElement))) {
      e.preventDefault(); last.focus();
    } else if (!e.shiftKey && (document.activeElement === last || !items.includes(document.activeElement))) {
      e.preventDefault(); first.focus();
    }
  });

  function cartJSON(response) {
    return response.json().then(function (data) {
      if (!response.ok) throw new Error(data.description || data.message || 'Please try again.');
      return data;
    });
  }
  function showCartError(error) {
    var host = activeDrawer ? activeDrawer.querySelector('.cart-drawer__panel') : document.querySelector('[data-cart-page-section]') || document.querySelector('main');
    var box = host.querySelector('[data-cart-error]');
    if (!box) {
      box = document.createElement('p');
      box.dataset.cartError = '';
      box.className = 'cart-error';
      box.setAttribute('role', 'alert');
      host.prepend(box);
    }
    box.textContent = error.description || error.message || 'We could not update your cart. Please try again.';
  }
  function recoverCart(error) {
    return fetch('/cart.js').then(cartJSON).then(function (cart) {
      updateCartCount(cart);
      return Promise.all([refreshDrawer(null), updateCartPage(cart)]);
    }).catch(function () {}).then(function () { showCartError(error); });
  }

  /* ---------------- Cart state ---------------- */
  function updateCartCount(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
    });
  }

  /* ---------------- Freebie auto-add ----------------
     Theme settings map $0 freebie products to spend tiers. When the
     (non-freebie) subtotal crosses a tier the freebie is added; if the
     cart drops below, it's removed. Manual removals stick for the session. */
  var freebieCfg = (window.SBJ && window.SBJ.freebies) || [];
  var freebieIds = freebieCfg.map(function (f) { return f.id; });
  var freebieSyncing = false;

  function freebieRemovals() {
    try { return JSON.parse(sessionStorage.getItem('sbj-freebie-removed') || '{}'); } catch (e) { return {}; }
  }
  function rememberFreebieRemoval(variantId) {
    if (freebieIds.indexOf(Number(variantId)) === -1) return;
    var removed = freebieRemovals();
    removed[variantId] = 1;
    try { sessionStorage.setItem('sbj-freebie-removed', JSON.stringify(removed)); } catch (e) {}
  }

  function syncFreebies(cart) {
    if (!freebieCfg.length || freebieSyncing || !cart) return Promise.resolve(cart);
    var removed = freebieRemovals();
    var subtotal = 0;
    var paidCount = 0;
    var present = {};
    var ops = [];
    cart.items.forEach(function (item) {
      if (freebieIds.indexOf(item.variant_id) > -1) {
        present[item.variant_id] = item;
      } else if (item.product_type === 'Monthly Freebie' && item.final_price === 0) {
        ops.push({ change: item.key, quantity: 0 });
      } else if (item.final_price > 0) {
        /* zero-price lines (e.g. last month's freebie still in an old cart)
           never count toward unlocking tiers */
        subtotal += item.final_line_price;
        paidCount += item.quantity;
      }
    });
    freebieCfg.forEach(function (f) {
      var entitled = paidCount > 0 && subtotal >= f.min;
      var line = present[f.id];
      if (entitled && !line && !removed[f.id]) {
        ops.push({ add: f.id });
      } else if (line && !entitled) {
        ops.push({ change: line.key, quantity: 0 });
      } else if (line && line.quantity !== 1) {
        ops.push({ change: line.key, quantity: 1 });
      }
    });
    if (!ops.length) return Promise.resolve(cart);
    freebieSyncing = true;
    var chain = Promise.resolve();
    ops.forEach(function (op) {
      chain = chain.then(function () {
        if (op.add) {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: op.add, quantity: 1 })
          });
        }
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: op.change, quantity: op.quantity })
        });
      });
    });
    return chain
      .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
      .then(function (fresh) {
        freebieSyncing = false;
        updateCartCount(fresh);
        return refreshDrawer(null).then(function () { return fresh; });
      })
      .catch(function () { freebieSyncing = false; return cart; });
  }

  function refreshDrawer(sectionsHtml, cart) {
    if (cart) updateCartCount(cart);
    if (!drawer) return Promise.resolve();
    var apply = function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('.cart-drawer__panel');
      var current = drawer.querySelector('.cart-drawer__panel');
      if (fresh && current) {
        var restoreFocus = current.contains(document.activeElement);
        current.innerHTML = fresh.innerHTML;
        if (restoreFocus) (current.querySelector('.cart-drawer__close') || drawer).focus({ preventScroll: true });
        bindDrawerChrome();
        bindCartControls(drawer);
      }
      var freshCount = doc.querySelector('[data-cart-count]');
      if (freshCount) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = freshCount.textContent;
        });
      }
    };
    if (sectionsHtml) { apply(sectionsHtml); return Promise.resolve(); }
    return fetch(window.location.pathname + '?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) { if (data['cart-drawer']) apply(data['cart-drawer']); })
      .catch(function () {});
  }

  function addToCart(body) {
    body.sections = 'cart-drawer';
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw e; });
        return r.json();
      })
      .then(function (item) {
        var html = item.sections && item.sections['cart-drawer'];
        return fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            return refreshDrawer(html, cart).then(function () { return syncFreebies(cart); });
          });
      });
  }

  function changeCart(payload) {
    payload.sections = 'cart-drawer';
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(cartJSON)
      .then(function (cart) {
        var html = cart.sections && cart.sections['cart-drawer'];
        updateCartCount(cart);
        return refreshDrawer(html)
          .then(function () { return syncFreebies(cart); })
          .then(function (fresh) { return fresh || cart; });
      });
  }

  /* Serialise cart writes. Rapid clicks on the qty steppers would otherwise
     race and leave the drawer rendering an out-of-date total. */
  var cartQueue = Promise.resolve();
  function queueCartChange(payload) {
    cartQueue = cartQueue
      .catch(function () {})
      .then(function () { return changeCart(payload); });
    return cartQueue;
  }

  /* quick add buttons (product cards, drawer upsell) */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    var variantId = btn.dataset.quickAdd;
    if (!variantId) return;
    var original = btn.textContent;
    btn.disabled = true;
    btn.textContent = btn.dataset.addingText || 'ADDING…';
    addToCart({ id: Number(variantId), quantity: 1 })
      .then(function () {
        btn.textContent = btn.dataset.addedText || 'ADDED ✓';
        openDrawer();
        setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 1200);
      })
      .catch(function (err) {
        btn.textContent = 'TRY AGAIN';
        showCartError(err);
        setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 1600);
      });
  });

  /* product form (product page) */
  document.querySelectorAll('form.product-form, form[action*="/cart/add"]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      if (!drawer || drawer.dataset.enabled === 'false') return; // regular submit
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var original = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = btn.dataset.addingText || 'ADDING…'; }
      var id = Number(form.querySelector('[name="id"]').value);
      var qtyInput = form.querySelector('[name="quantity"]');
      var qty = qtyInput ? Number(qtyInput.value) || 1 : 1;
      addToCart({ id: id, quantity: qty })
        .then(function () { openDrawer(); })
        .catch(function (err) {
          showCartError(err);
        })
        .then(function () {
          if (btn) { btn.disabled = false; btn.textContent = original; }
        });
    });
  });

  /* qty steppers + removes + note (cart page & drawer) */
  function bindCartControls(scope) {
    scope.querySelectorAll('[data-qty-change]').forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var key = btn.dataset.line;
        var input = scope.querySelector('[data-qty-input][data-line="' + key + '"]');
        if (!input) return;
        var next = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(btn.dataset.qtyChange, 10));
        input.value = next;
        queueCartChange({ id: key, quantity: next }).then(function (cart) { return updateCartPage(cart); }).catch(recoverCart);
      });
    });
    scope.querySelectorAll('[data-line-remove]').forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (btn.dataset.variantId) rememberFreebieRemoval(btn.dataset.variantId);
        queueCartChange({ id: btn.dataset.lineRemove, quantity: 0 }).then(function (cart) { return updateCartPage(cart); }).catch(recoverCart);
      });
    });
    scope.querySelectorAll('[data-cart-note]').forEach(function (area) {
      if (area.dataset.bound) return;
      area.dataset.bound = '1';
      var t;
      area.addEventListener('input', function () {
        clearTimeout(t);
        t = setTimeout(function () {
          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ note: area.value })
          }).then(cartJSON).catch(showCartError);
        }, 500);
      });
    });
  }
  bindCartControls(document);

  /* cart page live updates: on any change, if we're on /cart re-render via section API */
  function updateCartPage(cart) {
    var main = document.querySelector('[data-cart-page-section]');
    if (!main) return Promise.resolve();
    if (cart && cart.item_count === 0) { window.location.reload(); return; }
    var sectionId = main.dataset.cartPageSection;
    return fetch(window.location.pathname + '?sections=' + sectionId)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data[sectionId]) return;
        var doc = new DOMParser().parseFromString(data[sectionId], 'text/html');
        var fresh = doc.querySelector('[data-cart-page-section]');
        if (fresh) {
          main.innerHTML = fresh.innerHTML;
          bindCartControls(main);
        }
      });
  }

  /* freebie/free-shipping progress rendered server-side; nothing extra needed */

  /* reconcile freebies on page load (covers tier/setting changes made in admin) */
  if (freebieCfg.length) {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart.item_count === 0) return;
        return syncFreebies(cart).then(function (fresh) {
          if (fresh && fresh.item_count !== cart.item_count) updateCartPage(fresh);
        });
      })
      .catch(function () {});
  }

  /* ---------------- Product gallery ---------------- */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var mainImg = gallery.querySelector('[data-gallery-main]');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (!mainImg) return;
        mainImg.src = thumb.dataset.full;
        if (thumb.dataset.srcset) mainImg.srcset = thumb.dataset.srcset; else mainImg.removeAttribute('srcset');
        if (thumb.dataset.zoom) mainImg.dataset.zoomSrc = thumb.dataset.zoom;
        mainImg.alt = thumb.alt || '';
        gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
          t.classList.toggle('product__thumb--active', t === thumb);
        });
      });
    });

    /* ---- full-screen zoom ---- */
    var modal = document.querySelector('[data-zoom-modal]');
    if (!modal || !mainImg) return;
    var stage = modal.querySelector('[data-zoom-stage]');
    var zoomImg = modal.querySelector('[data-zoom-img]');
    var closeBtn = modal.querySelector('[data-zoom-close]');
    var openBtn = gallery.querySelector('[data-zoom-open]');
    var zoomed = false;

    function setZoom(on) {
      zoomed = on;
      stage.classList.toggle('zoom-modal__stage--zoomed', on);
      if (!on) zoomImg.style.transform = '';
    }

    function pan(e) {
      if (!zoomed) return;
      var r = stage.getBoundingClientRect();
      var x = ((e.clientX - r.left) / r.width - 0.5) * -100;
      var y = ((e.clientY - r.top) / r.height - 0.5) * -100;
      zoomImg.style.transform = 'scale(2.2) translate(' + x / 2.2 + '%, ' + y / 2.2 + '%)';
    }

    function open() {
      zoomImg.src = mainImg.dataset.zoomSrc || mainImg.currentSrc || mainImg.src;
      zoomImg.alt = mainImg.alt || '';
      setZoom(false);
      modal.hidden = false;
      document.body.classList.add('drawer-open');
      closeBtn.focus();
    }

    function close() {
      modal.hidden = true;
      setZoom(false);
      document.body.classList.remove('drawer-open');
    }

    mainImg.addEventListener('click', open);
    if (openBtn) openBtn.addEventListener('click', open);
    closeBtn.addEventListener('click', function (e) {
      /* keep the click off the stage so it can't re-trigger the zoom toggle */
      e.stopPropagation();
      close();
    });
    stage.addEventListener('click', function (e) {
      if (e.target === stage) { close(); return; }
      setZoom(!zoomed);
      if (zoomed) pan(e);
    });
    stage.addEventListener('mousemove', pan);
    document.addEventListener('keydown', function (e) {
      if (modal.hidden) return;
      if (e.key === 'Escape') close();
    });
  });

  /* ---------------- Wishlist heart (local only) ---------------- */
  document.querySelectorAll('[data-wishlist]').forEach(function (btn) {
    var key = 'sbj-wishlist';
    var handle = btn.dataset.wishlist;
    var list = [];
    try { list = JSON.parse(localStorage.getItem(key) || '[]'); } catch (e) {}
    function paint() {
      var on = list.indexOf(handle) > -1;
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.textContent = on ? '♥' : '♡';
    }
    btn.addEventListener('click', function () {
      var i = list.indexOf(handle);
      if (i > -1) list.splice(i, 1); else list.push(handle);
      try { localStorage.setItem(key, JSON.stringify(list)); } catch (e) {}
      paint();
    });
    paint();
  });

  /* ---------------- Collection: load more (mobile) ---------------- */
  var loadMoreBtn = document.querySelector('[data-load-more]');
  if (loadMoreBtn) {
    document.documentElement.classList.add('load-more-ready');
    loadMoreBtn.addEventListener('click', function (e) {
      e.preventDefault();
      var url = loadMoreBtn.dataset.nextUrl;
      if (!url || loadMoreBtn.disabled) return;
      loadMoreBtn.disabled = true;
      loadMoreBtn.setAttribute('aria-busy', 'true');
      loadMoreBtn.textContent = 'LOADING…';
      fetch(url)
        .then(function (r) { if (!r.ok) throw new Error('Unable to load products'); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var grid = document.querySelector('[data-collection-grid]');
          var freshGrid = doc.querySelector('[data-collection-grid]');
          if (!grid || !freshGrid) throw new Error('Unable to load products');
          if (grid && freshGrid) {
            while (freshGrid.firstChild) grid.appendChild(freshGrid.firstChild);
          }
          var freshBtn = doc.querySelector('[data-load-more]');
          if (freshBtn && freshBtn.dataset.nextUrl) {
            loadMoreBtn.dataset.nextUrl = freshBtn.dataset.nextUrl;
            loadMoreBtn.textContent = loadMoreBtn.dataset.label || 'LOAD MORE';
          } else {
            loadMoreBtn.closest('.load-more-wrap').hidden = true;
          }
        }).catch(function () {
          loadMoreBtn.textContent = 'Could not load — tap to retry';
        }).finally(function () {
          loadMoreBtn.disabled = false;
          loadMoreBtn.removeAttribute('aria-busy');
        });
    });
  }

  /* ---------------- Collection sort ---------------- */
  document.querySelectorAll('[data-sort-select]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  /* ---------------- Discount code (cart page + drawer, delegated) ---------------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-discount-form]');
    if (!form) return;
    e.preventDefault();
    var input = form.querySelector('input');
    var code = (input.value || '').trim();
    if (!code) return;
    // Shopify applies discount codes at checkout; stash it so checkout picks it up.
    document.cookie = 'discount_code=' + encodeURIComponent(code) + '; path=/';
    fetch('/discount/' + encodeURIComponent(code)).finally(function () {
      var msg = form.parentElement.querySelector('[data-discount-msg]') || form.querySelector('[data-discount-msg]');
      if (msg) {
        msg.hidden = false;
        msg.textContent = '“' + code + '” will be applied at checkout.';
      }
    });
  });

  /* ---------------- Search category dropdown ----------------
     Folds the chosen category into the query using Shopify's native
     field syntax (product_type:"…"), which works on every store — the
     filter.p.* param alone only applies when storefront search filters
     are configured in Search & Discovery. */
  document.querySelectorAll('.site-header__search').forEach(function (form) {
    var sel = form.querySelector('.site-header__search-cats');
    if (!sel) return;
    form.addEventListener('submit', function () {
      var q = form.querySelector('input[name="q"]');
      var type = sel.value;
      sel.disabled = true; // keep the unused filter param out of the URL
      if (!q || !type) return;
      var term = q.value.trim();
      q.value = (term ? term + ' ' : '') + 'product_type:"' + type + '"';
    });
  });

  /* ---------------- Mega menu: tap-to-open on touch devices ---------------- */
  var hoverless = window.matchMedia('(hover: none)');
  document.querySelectorAll('.site-header__nav-item--mega > a').forEach(function (link) {
    link.addEventListener('click', function (e) {
      if (!hoverless.matches) return;
      var li = link.parentElement;
      if (!li.classList.contains('is-open')) {
        e.preventDefault();
        document.querySelectorAll('.site-header__nav-item--mega.is-open').forEach(function (open) {
          open.classList.remove('is-open');
        });
        li.classList.add('is-open');
      }
    });
  });
  document.addEventListener('click', function (e) {
    if (e.target.closest('.site-header__nav-item--mega')) return;
    document.querySelectorAll('.site-header__nav-item--mega.is-open').forEach(function (open) {
      open.classList.remove('is-open');
    });
  });
})();
